import routeDataSelectorFactory from "./routeDataSelectorFactory.jsx"

export default routeDataSelectorFactory((state) =>
  state.previousLocation != null ? state.previousLocation.get("pathname") : null,
)
